'use strict';

var JSConstants = require('_core_ext/pages/product/constants'),
    cssConstants = require('_core_ext/cssconstants'),
    util = require('_core_ext/util');

var visibilityChangeStep = 5;

function initializeReviews() {
    setLinkText();

    var $globalRatingContainer = $(JSConstants.CLASS_FEEFO_GLOBALRATING),
        $reviewsMiniSection = $(JSConstants.CLASS_PDP_MINIRATING),
        rating = parseInt($globalRatingContainer.data('rating') || 0),
        reviewsCount = parseInt($globalRatingContainer.data('reviewscount') || 0);

    $reviewsMiniSection.find(JSConstants.CLASS_FEEFO_RATING_NUMBER).text(reviewsCount);
    $reviewsMiniSection.find('.feefo-rating_container .feefo-rating_starson').css('cssText', 'width: ' + rating + '% !important');
}

function setLinkText() {
    var $hiddenReviews = $(JSConstants.CLASS_FEEFO_REVIEW_CONTAINER + '.' + cssConstants.HIDDEN);
    if ($hiddenReviews.length === 0) {
        $(JSConstants.CLASS_FEEFO_MORELINK).text(Resources.FEEFO_READ_ON_SITE);
    }
}

function initializeEvents() {
    $(document).one('pdp.updated', function() {
        initializeReviews();
        initializeEvents();
    });
    $(JSConstants.CLASS_FEEFO_MORELINK).off('click.feefo').on('click.feefo', function(e) {
        var $hiddenReviews = $(JSConstants.CLASS_FEEFO_REVIEW_CONTAINER + '.' + cssConstants.HIDDEN);
        if ($hiddenReviews.length > 0) {
            e.preventDefault();
            $(JSConstants.CLASS_FEEFO_REVIEW_CONTAINER + '.' + cssConstants.HIDDEN + ':lt(' + visibilityChangeStep + ')').removeClass(cssConstants.HIDDEN);
            setLinkText();
        }
    });
    $(JSConstants.CLASS_PDP_MINIRATING).find(JSConstants.CLASS_FEEFO_RATINGVIEW).on('click', function(e) {
        e.preventDefault();
        var $reviewBlock = $(JSConstants.CLASS_PRODUCT_REVIEWS_SECTION);

        util.scrollBrowserTo($reviewBlock);
    });
}

var feefo = {
    init : function () {
        if (SitePreferences.FEEFO_ENABLED) {
            initializeReviews();
            initializeEvents();
        }
    }
};

module.exports = feefo;